import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Section.module.scss'
import { Text } from 'almanac-ui/Text/Text'
import cx from 'classnames'

interface SectionProps {
  title?: string
  columns: string[]
  children: React.ReactNode
  backgroundColor?: string
}

export const Section = ({ title, columns, children, backgroundColor }: SectionProps) => {
  const totalColumns = 1 + columns.length
  const headerClasses = cx(Styles.header, totalColumns === 3 ? Styles.columns3 : Styles.columns4)
  return (
    <div className={Styles.root}>
      <div className={headerClasses}>
        {title && (
          <div className={Styles.headerItem}>
            <Heading level={4}>{title}</Heading>
          </div>
        )}
        {columns.map((column, idx) => (
          <div
            className={cx(Styles.headerItem, idx === 0 ? Styles.accountHeader : undefined)}
            key={`${column || 'empty'}-${idx}`}
          >
            {column ? <Text variant="label">{column}</Text> : null}
          </div>
        ))}
      </div>
      <div className={Styles.content} style={{ backgroundColor }}>
        {children}
      </div>
    </div>
  )
}
